import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
class AutoFixBanner extends Component {
    render() {
        const { t, handleShowDetail, extension, options } = this.props;
        const files = options.files && Array.isArray(options.files)
            ? options.files
            : options && Array.isArray(options)
                ? options
                : [];
        const areIssuesPresent = options.issuesCount && options.issuesCount !== 0;
        const issuesCount = areIssuesPresent
            ? options.issuesCount
                ? Number(options.issuesCount)
                : 0
            : options.files.length === 1 && Array.isArray(options.files[0])
                ? options.files[0].length
                : options.files.length;
        const issuesCountFormatted = new Intl.NumberFormat(t('numberFormatLocale')).format(issuesCount);
        const isJs = extension === 'js';
        const isPhp = extension === 'php';
        return (_jsxs("div", { className: "alert alert-secondary d-flex", children: [_jsx(Icon, { name: "info-circle-o text-info mr-3" }), _jsx("div", { className: "d-flex w-100", children: _jsxs("div", { className: "d-flex justify-content-between w-100", children: [_jsxs("div", { children: [_jsx("div", { className: "font-weight-bold", children: t('autoFixes', { issuesCount: issuesCountFormatted }) }), isJs ? t('ignoreGeneratedFilesJS') : '', isPhp ? t('ignoreGeneratedFilesPHP') : ''] }), _jsx("button", { className: "btn btn-primary btn-sm", title: t('showDetails'), onClick: () => handleShowDetail(files, issuesCount, extension), children: t('showDetails') })] }) })] }));
    }
}
export default withTranslation()(AutoFixBanner);
